import { UIRouteInfo } from "@flights/types";

export type State = UIRouteInfo | null;

// eslint-disable-next-line no-restricted-syntax -- this line was auto generated, hence fix the issue timely
export const getInitialState = (): State => null;
